// SortContent.tsx
import React from 'react'
import SortItem from './sort-item' // Adjust the import based on your file structure
import { stopPropagation } from '../../../../utils/dom-utils'
import { Content } from './styles'
import SortOptionTransport from '../../../../transports/common/sort-option-transport'
import { useSelector } from 'react-redux'
import { getSortOptions } from '../../../../redux/filters/selectors'

interface SortContentProps {
    sortOptions?: SortOptionTransport[] | null // Replace 'any' with the actual type of sort options
    handleSortSubmit: (link: string) => void
    getDisplayLabel?: (label: string) => string
    className?: string
    isModal?: boolean
    isSortOpen: boolean
}

const SortContent: React.FC<SortContentProps> = ({
    handleSortSubmit,
    getDisplayLabel,
    className,
    isModal = false,
    isSortOpen,
}) => {
    const sortOptions = useSelector(getSortOptions)

    return (
        <Content className={className} onMouseDown={stopPropagation} isModal={isModal} isSortOpen={isSortOpen}>
            {sortOptions?.map(sort => {
                return (
                    <SortItem
                        sortItem={sort}
                        key={sort.label + sort.order}
                        onSortSubmit={handleSortSubmit}
                        getDisplayLabel={getDisplayLabel}
                    />
                )
            })}
        </Content>
    )
}

export default SortContent
